// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/license_type.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/license_type.proto.
 */
export const file_bfftypes_v1_license_type: GenFile = /*@__PURE__*/
  fileDesc("Ch5iZmZ0eXBlcy92MS9saWNlbnNlX3R5cGUucHJvdG8SC2JmZnR5cGVzLnYxKrUBCgtMaWNlbnNlVHlwZRIcChhMSUNFTlNFX1RZUEVfVU5TUEVDSUZJRUQQABIbChdMSUNFTlNFX1RZUEVfR0VORVJBVElPThABEhcKE0xJQ0VOU0VfVFlQRV9SRVRBSUwQAhIdChlMSUNFTlNFX1RZUEVfVFJBTlNNSVNTSU9OEAMSEwoPTElDRU5TRV9UWVBFX0RSEAQSHgoaTElDRU5TRV9UWVBFX1NFTEZfV0hFRUxJTkcQBUJCWkBnaXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ0eXBlcy92MTtiZmZ0eXBlc3YxYgZwcm90bzM");

/**
 * LicenseType is the regulated electricity-business license category an
 * OCCTO-registered entity operates under. Mirrors backend
 * types.v1.LicenseType 1:1 (5 values: 発電 / 小売 / 送配電 / 需要抑制
 * / 自己託送) — order and numbering match the mock-app C# enum.
 *
 * BusinessMaster surfaces all five values. BgMaster surfaces a 4-value
 * subset (LICENSE_TYPE_TRANSMISSION never appears for BG rows; the
 * backend domain constructor rejects it).
 *
 * Hosted under bfftypes/v1 (= shared across BFF service packages) so
 * future master / read-side BFF APIs can reuse the same enum without
 * duplicating it per service. BFF's contract with the frontend is
 * intentionally decoupled from backend internal types (= same
 * convention as bfftypes/v1/area.proto).
 *
 * @generated from enum bfftypes.v1.LicenseType
 */
export enum LicenseType {
  /**
   * @generated from enum value: LICENSE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 発電
   *
   * @generated from enum value: LICENSE_TYPE_GENERATION = 1;
   */
  GENERATION = 1,

  /**
   * 小売
   *
   * @generated from enum value: LICENSE_TYPE_RETAIL = 2;
   */
  RETAIL = 2,

  /**
   * 送配電 (BusinessMaster only)
   *
   * @generated from enum value: LICENSE_TYPE_TRANSMISSION = 3;
   */
  TRANSMISSION = 3,

  /**
   * 需要抑制
   *
   * @generated from enum value: LICENSE_TYPE_DR = 4;
   */
  DR = 4,

  /**
   * 自己託送
   *
   * @generated from enum value: LICENSE_TYPE_SELF_WHEELING = 5;
   */
  SELF_WHEELING = 5,
}

/**
 * Describes the enum bfftypes.v1.LicenseType.
 */
export const LicenseTypeSchema: GenEnum<LicenseType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_license_type, 0);

